module.exports = __webpack_public_path__ + "media/images/lightbox/prev-57cffd387ffa8d31834a595d9682b63d.png";